/* eslint-disable prettier/prettier */
export interface BrandProfile {
  id: 'alphastar' | 'executive-jet';
  hostnames: string[];
  companyName: string;
  sidebarTitle: string;
  welcomeTitle: string;
  logoUrl: string;
  markUrl: string;
  loginBackgroundUrl?: string;
  primaryColor: string;
  buttonColor: string;
  privacyPolicyUrl: string;
  footerUrl: string;
  footerLabel: string;
  isDefault: boolean;
}

export const BRAND_PROFILES: BrandProfile[] = [
  {
    id: 'alphastar',
    hostnames: [], // TODO: add the hostnames for the alphastar
    companyName: 'Alphastar',
    sidebarTitle: 'Faturti',
    welcomeTitle: 'Welcome to Alpha Star Aviation',
    logoUrl: 'assets/img/alphastar-logo.png', // TODO: the logo in the login page & welcome page
    markUrl: 'assets/img/logo.svg', // TODO: the logo in the sidebar
    loginBackgroundUrl: 'assets/img/alphastar_profile.PNG', // TODO: the background image for the login page
    primaryColor: '#012758', // TODO: the primary color for the application
    buttonColor: '#203586', // TODO: the button color for the application
    privacyPolicyUrl: 'https://www.alphastarav.com/en/PrivacyPolicy.aspx', // TODO: the privacy policy url
    footerUrl: 'https://www.alphastarav.com/', // TODO: the footer company website url
    footerLabel: 'alphastarav.com', // TODO: the footer company website label
    isDefault: true,
  },
  {
    id: 'executive-jet',
    hostnames: ['ejc.localhost'], // TODO: add the hostnames for the executive jet
    companyName: 'The Executive Jet Company',
    sidebarTitle: 'Faturti',
    welcomeTitle: 'Welcome to The Executive Jet Company',
    logoUrl: 'assets/img/ejc.jpeg', // TODO: the logo in the login page & welcome page
    markUrl: 'assets/img/logo.svg', // TODO: the logo in the sidebar
    loginBackgroundUrl: 'assets/img/alphastar_profile.PNG', // TODO: the background image for the login page
    primaryColor: '#343a40', // TODO: the primary color for the application
    buttonColor: '#343a40', // TODO: the button color for the application
    privacyPolicyUrl: 'https://www.alphastarav.com/en/PrivacyPolicy.aspx', // TODO: the privacy policy url
    footerUrl: 'https://www.alphastarav.com/', // TODO: the footer company website url
    footerLabel: 'The Executive Jet Company', // TODO: the footer company website label
    isDefault: false,
  },
];
